<template>
  <div class="grid-container mt-0">
    <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="companies" :allowColumnResizing="true"
      key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50" :columnResizingMode="'nextColumn'"
      :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-column-lines="false"
      @selectionChanged="onSelectionChanged" @row-removing="onRowRemoving" @editing-start="onEditingStart">
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="15" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="Utilizatori" />
      <DxSelection mode="single" />
      <DxSearchPanel :visible="true" :width="240" placeholder="Cauta ..."></DxSearchPanel>
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="550" :height="350">
          <DxToolbarItem :template="customTitleTemplate" />

          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />

          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />

          <DxToolbarItem toolbar="bottom" widget="dxButton" location="before" :options="{
            text: 'Resetează parola',
            type: 'default',
            stylingMode: 'outlined',
            onClick: onResetPassword
          }" />

        </DxPopup>

        <DxFormGrid :col-span="1" :col-count="1" item-type="group">
          <DxItem data-field="Active" editor-type="dxCheckBox" />
          <DxItem data-field="Email" :editor-options="{ width: '100%' }" :label="{ text: 'Email', location: 'top' }" />
          <DxItem data-field="AgentDefault" editor-type="dxSelectBox" :label="{ text: 'Agent Asociat' }"
            :editor-options="{
              dataSource: dsAgenti,
              displayExpr: 'Nume',
              valueExpr: 'Id',
              searchEnabled: true,
              searchMode: 'contains',
              searchExpr: 'Nume',
              placeholder: 'Căutați agentul...',
              noDataText: 'Nu există agenți care să corespundă'
            }" />
          <DxItem data-field="PunctLucruId" editor-type="dxSelectBox" :label="{ text: 'Punct de lucru' }"
            :editor-options="{
              dataSource: structuraCompanieFlat,
              displayExpr: 'DisplayNume',
              valueExpr: 'Id',
              itemTemplate: structuraItemTemplate,
              searchEnabled: true,
              searchMode: 'contains',
              searchExpr: 'Nume',
              showClearButton: true,
              placeholder: 'Selectați punctul de lucru...',
              noDataText: 'Nu există puncte de lucru configurate'
            }" />
        </DxFormGrid>
      </DxEditing>

      <DxColumn caption="Utilizator" data-field="Username" />
      <DxColumn data-field="AgentDefault" caption="Agent Asociat">
        <DxLookup :data-source="dsAgenti" value-expr="Id" display-expr="Nume" />
      </DxColumn>
      <DxColumn data-field="Email" />
      <DxColumn data-field="Active" />
      <DxColumn data-field="PunctLucruNume" caption="Punct de lucru" :allow-editing="false" />
      <!-- Coloană ascunsă, necesară pentru ca DevExtreme să urmărească modificările pe acest câmp
           în editing.changes — form item-ul de mai sus, fără coloană corespunzătoare, nu era
           înregistrat ca modificare la salvare ("Nu există modificări"). -->
      <DxColumn data-field="PunctLucruId" :visible="false" />
    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" title="Adăugare Utilizator" :width="600" :height="380">

      <div>

        <DxForm :form-data="formData">

          <DxItem :col-span="1" item-type="group">

            <DxItem data-field="ID" editor-type="dxSelectBox" :label="{ text: 'Utilizator' }" :editor-options="{
              items: unallocatedUsers,
              displayExpr: 'Username',
              valueExpr: 'ID',
              searchEnabled: true,
              searchMode: 'contains',
              searchExpr: 'Username',
              placeholder: 'Selectați utilizatorul',
              noDataText: 'Nu am găsit utilizatori'
            }" />

            <DxItem data-field="AgentDefault" editor-type="dxSelectBox" :label="{ text: 'Agent Asociat' }"
              :editor-options="{
                dataSource: dsAgenti,
                displayExpr: 'Nume',
                valueExpr: 'Id',
                searchEnabled: true,
                searchMode: 'contains',
                searchExpr: 'Nume',
                placeholder: 'Căutați agentul...',
                noDataText: 'Nu există agenți care să corespundă'
              }" />

            <DxItem data-field="PunctLucruId" editor-type="dxSelectBox" :label="{ text: 'Punct de lucru' }"
              :editor-options="{
                dataSource: structuraCompanieFlat,
                displayExpr: 'DisplayNume',
                valueExpr: 'Id',
                searchEnabled: true,
                searchMode: 'contains',
                searchExpr: 'Nume',
                showClearButton: true,
                placeholder: 'Selectați punctul de lucru...',
                noDataText: 'Nu există puncte de lucru configurate'
              }" />
          </DxItem>

        </DxForm>

        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 15px;">

          <DxButton text="Salvează" type="success" @click="onSave" />

          <DxButton text="Închide" type="danger" @click="onCancel" />

        </div>

      </div>

    </DxPopupAdd>
  </div>
</template>
<script lang="ts">
import { DxSelectBox } from 'devextreme-vue/select-box';
import { defineComponent, ref } from 'vue'


import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxLoadPanel,
  DxPaging,
  DxSearchPanel,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxTexts,
  DxEditing,
  DxToolbar,
  DxValidationRule,
  DxRequiredRule,
  DxPopup,
  DxForm as DxFormGrid,
  DxLookup
} from 'devextreme-vue/data-grid';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import AUTH_DrepturiUtilizatori from '@/services/AUTH/AUTH_DrepturiUtilizatori';
import ResponseData from '@/types/responseData'
import DxSpeedDialAction from 'devextreme-vue/speed-dial-action';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxItem, DxForm } from 'devextreme-vue/form';
import UserCompanyServices from '@/services/Administrare/UserCompanyService';
import UserService from '@/services/Administrare/UserService';
import { locale, loadMessages } from 'devextreme/localization';
import AUTH_Users from '@/services/AUTH/AUTH_Users';
import AppSettings from '@/settings/appSettings';
export default defineComponent({
  components: {
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxSearchPanel,
    DxStateStoring,
    DxEditing,
    DxColumnChooser,
    DxLoadPanel,
    DxPaging,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxToolbar,
    DxButton,
    DxPopupAdd,
    DxItem,
    DxForm,
    DxValidationRule,
    DxRequiredRule,
    DxToolbarItem,
    DxPopup,
    DxSpeedDialAction,
    DxFormGrid,
    DxSelectBox,
    DxLookup

  },
  data() {
    return {
      editId: null as string | null,
      companies: [],
      dsAgenti: [],
      structuraCompanieFlat: [] as any[],
      isModalVisible: false,
      unallocatedUsers: [],
      selectedUser: null,
      dataGridRef: ref<DxDataGrid | null>(null),
      formData: { ID: null, Email: '', AgentDefault: null, PunctLucruId: null },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      customTitleTemplate() {
        return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:570px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
      },
    }
  },
  methods: {
    async onResetPassword() {
      const grid = this.$refs.dataGridRef?.instance;
      const changes = grid?.option('editing.changes') || [];
      const key = changes[0]?.key ?? grid?.option('editing.editRowKey') ?? this.editId;
      const row = key != null ? await this.getRowDataByKey(key) : null;
      const companyId = row?.UserCompanyID ?? row?.ID;

      if (!companyId) { notify('Nu am UserCompanyID.', 'error', 2000); return; }

      const { data } = await UserCompanyServices.generateRandomPassword(companyId);

      if (data?.password) {
        const pwd = String(data.password);
        try { await navigator.clipboard.writeText(pwd); } catch { }
        notify(`Parolă generată: ${pwd} (copiată în clipboard)`, 'success', 4000);
      } else if (data?.emailSent) {
        notify('Parola a fost resetată și trimisă pe e-mail.', 'success', 3000);
      } else {
        notify('Resetarea a reușit, dar răspunsul nu conține detalii.', 'info', 3000);
      }
    },
    onEditingStart(e) {
      this.editId = e.key;
      this.formData = { ...e.data };

      // LOG PENTRU DEBUG:
      console.log("Valoarea agentului pe acest rand:", e.data.AgentDefault);
      console.log("Lista de agenti disponobili:", this.dsAgenti);
    },
    onClick() {
      this.isModalVisible = true;
    },
    getUserCompanies() {
      UserCompanyServices.getAll()
        .then((response: ResponseData) => {
          this.companies = response.data;
        })
        .catch((e: Error) => {
          console.log(e)
        });
    },
    getUser() {
      UserService.getUsersNotAdded()
        .then((response: ResponseData) => {
          this.unallocatedUsers = response.data;
        })
        .catch((e: Error) => {
          console.log(e)
        });
    },
    getAgenti() {
      AUTH_Users.getAgenti()
        .then(r => {
          // OData returnează datele în r.data.value
          // API-urile simple returnează datele în r.data
          this.dsAgenti = r.data.value || r.data || [];
          console.log("Agenti incarcati în grid:", this.dsAgenti);
        })
        .catch(console.error);
    },
    getStructuraCompanie() {
      AUTH_Users.getStructuraCompanie()
        .then((r: any) => {
          const items = r.data?.value ?? r.data ?? [];
          this.structuraCompanieFlat = this.buildStructuraFlat(items);
        })
        .catch(console.error);
    },
    // Listă plată, ordonată DFS pe baza ParentId, cu adâncime (_depth) reținută per rând pentru
    // indentare vizuală reală în itemTemplate (structuraItemTemplate) — un dropdown simplu
    // (dxSelectBox), nu un arbore expandabil: mecanismul de template custom în DxForm
    // (DxDropDownBox+DxTreeView montate prin slot "template=") s-a dovedit nefiabil — DevExtreme
    // montează acel slot ca instanță Vue izolată (mountTemplate), deci valoarea nu se actualiza
    // reactiv la selecție și ref-ul folosit pentru închiderea dropdown-ului nu era vizibil din
    // afara acelei instanțe izolate. dxSelectBox e mecanismul deja funcțional, folosit și la
    // AgentDefault mai sus; itemTemplate de mai jos e JS/DOM nativ DevExtreme (nu Vue), deci nu
    // are aceeași problemă — doar afișează, nu scrie valoarea înapoi.
    buildStructuraFlat(flat: any[], parentId: string | null = null, depth = 0): any[] {
      const pid = parentId != null ? String(parentId).toLowerCase() : null;
      const copii = flat.filter(i => {
        const p = i.ParentId != null ? String(i.ParentId).toLowerCase() : null;
        return p === pid;
      });
      let result: any[] = [];
      for (const item of copii) {
        result.push({ ...item, DisplayNume: item.Nume || '', _depth: depth });
        result = result.concat(this.buildStructuraFlat(flat, item.Id, depth + 1));
      }
      return result;
    },
    // itemTemplate nativ DevExtreme (nu componentă Vue) — randează fiecare rând din dropdown
    // cu indentare reală (padding) după adâncime, conector vizual și iconiță diferită pentru
    // gestiuni (EsteGestiune) față de restul nivelurilor din structură.
    structuraItemTemplate(itemData: any) {
      const row = document.createElement('div');
      row.style.display = 'flex';
      row.style.alignItems = 'center';
      row.style.gap = '6px';
      row.style.paddingLeft = `${(itemData._depth || 0) * 20}px`;

      if (itemData._depth > 0) {
        const connector = document.createElement('span');
        connector.textContent = '└';
        connector.style.color = '#94a3b8';
        connector.style.fontSize = '12px';
        row.appendChild(connector);
      }

      const icon = document.createElement('i');
      icon.className = `dx-icon ${itemData.EsteGestiune ? 'dx-icon-box' : 'dx-icon-folder'}`;
      icon.style.color = itemData.EsteGestiune ? '#059669' : '#94a3b8';
      icon.style.fontSize = '14px';
      row.appendChild(icon);

      const label = document.createElement('span');
      label.textContent = itemData.Nume || '';
      if (itemData.EsteGestiune) label.style.fontWeight = '600';
      row.appendChild(label);

      return row;
    },
    async getRowDataByKey(key) {
      const grid = this.$refs.dataGridRef?.instance;
      if (!grid) return null;

      const vis = grid.getVisibleRows();
      const found = vis.find(r => r.key === key)?.data;
      if (found) return found;

      const ds = grid.getDataSource?.();
      const store = ds?.store?.();
      if (store?.byKey) {
        try { return await store.byKey(key); } catch { return null; }
      }
      return null;
    },

    onRowRemoving(e) {
      const id = e.key;
      const promise = new Promise((resolve, reject) => {
        fetch(`${AppSettings.API_Url}AUTH_Users/DeleteUser/${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt')
          }
        })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text().catch(() => '');
              reject(`Delete failed: ${response.status} ${response.statusText} ${text}`);
              return;
            }
            resolve(false);
          })
          .catch((error) => reject(`Network error: ${error.message}`));
      });

      e.cancel = promise;
    },
    async onSaveEdit() {
      const grid = this.$refs.dataGridRef?.instance;
      const changes = grid?.option('editing.changes') || [];
      if (!changes.length) { notify('Nu există modificări.', 'info', 1500); return; }

      const change = changes[0];
      const keyId = change?.key;
      const delta = change?.data ?? {};

      const originalRow = keyId != null ? await this.getRowDataByKey(keyId) : null;

      // Construim payload-ul incluzând AgentDefault și PunctLucruId
      const payload = {
        Email: '',
        Active: false,
        AgentDefault: null as string | null,
        PunctLucruId: null as string | null,
      };

      payload.Email = ('Email' in delta)
        ? String((delta.Email ?? '').trim())
        : String(originalRow?.Email ?? '').trim();

      payload.Active = ('Active' in delta) ? !!delta.Active : !!originalRow?.Active;

      // IMPORTANT: Preluăm modificarea agentului din delta sau păstrăm originalul
      payload.AgentDefault = ('AgentDefault' in delta)
        ? delta.AgentDefault
        : originalRow?.AgentDefault;

      payload.PunctLucruId = ('PunctLucruId' in delta)
        ? delta.PunctLucruId
        : originalRow?.PunctLucruId;

      try {
        // Trimitem payload-ul complet (Email, Active, AgentDefault)
        await UserCompanyServices.updateByCompanyId(originalRow.UserCompanyID, payload);

        grid?.cancelEditData();
        await grid?.refresh();
        notify('Actualizat cu succes!', 'success', 1200);
        this.getUserCompanies();
      } catch (err) {
        notify('Eroare la salvare', 'error', 2000);
      }
    },

    onRefreshClick() {
      this.getUserCompanies();
      this.getUser();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onSave() {
      // Agentul (AgentDefault) este opțional — utilizatorul poate fi salvat și fără agent asociat.
      // Construim manual obiectul pentru a fi siguri de numele proprietăților
      const payload = {
        ID: this.formData.ID, // Asigură-te că ID este cu litere mari
        AgentDefault: this.formData.AgentDefault, // Asigură-te că AgentDefault este exact așa
        PunctLucruId: this.formData.PunctLucruId
      };

      console.log("DEBUG Payload:", payload);

      if (!payload.ID) {
        notify('Selectați un utilizator!', 'error', 2000);
        return;
      }

      UserCompanyServices.save(payload) // Trimitem payload-ul construit manual
        .then((response) => {
          notify('Salvat cu succes!', 'success', 1000);
          this.isModalVisible = false;
          this.getUserCompanies();
          // Resetăm forma după succes
          this.formData = { ID: null, Email: '', AgentDefault: null, PunctLucruId: null };
        })
        .catch((error) => {
          console.error("Eroare la server:", error);
          notify('Eroare la salvare!', 'error', 2000);
        });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return `<div>${itemData.text}</div>`;
    },
    onSelectionChanged(e: any) {
      const row = e?.selectedRowsData?.[0] ?? null;
      this.$emit('selection-changed', row);
    },
    onAddClick() {
      this.getUser();
      this.isModalVisible = true;
    },


    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
  },
  mounted() {
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.getUser();
    this.getAgenti();
    this.getStructuraCompanie();
    this.getUserCompanies();
    this.setDeleteConfirmationMessage();

    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });
    locale('ro');
  }
});

</script>
<style scoped>
.border {
  border-radius: 8px;
}
</style>
